import "./SignInButton.scss"
import React from 'react'
import { ReactComponent as RightArrow } from "../../assets/RightArrow.svg"

function SignInButton({ label, children, className, ...restProps }) {
  return (
    <button className="SignInButton py-2 text-sm font-medium w-8rem px-4" {...restProps}>
      <div className="SignInButtonContent" >
        <div className="SignInText text-lg">
          {label || children}
        </div>
        <div className="RightArrow absolute">
          <RightArrow />
        </div>
      </div>
    </button>
  )
}

export default SignInButton